var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-notifications-1220444",
    transform: "translate(-131.6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M141.19,2.081a7.847,7.847,0,0,0-6.769,7.2c0,1.358-.013,2.413,0,3.77a13.12,13.12,0,0,1-1.41,6.38,5.161,5.161,0,0,1-.854.959,1.762,1.762,0,0,0-.556,1.29v1.232a.858.858,0,0,0,.846.87h20.308a.858.858,0,0,0,.846-.87V21.677a1.762,1.762,0,0,0-.556-1.29,5.161,5.161,0,0,1-.854-.959,13.12,13.12,0,0,1-1.41-6.38c.013-1.357,0-2.412,0-3.77a7.848,7.848,0,0,0-6.769-7.2V1.45a1.411,1.411,0,1,0-2.821,0ZM142.6,29a4.292,4.292,0,0,1-4.231-4.35h8.462A4.292,4.292,0,0,1,142.6,29Z",
    transform: "translate(0 0)",
    fill: "#ddd",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.db03a25aa470f243802cb4b4086a5728.svg";
export { ForwardRef as ReactComponent };